import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useMemo } from 'react';
import { Box } from '@mui/material';
import { RangeTimeLine } from './time-line/time-range';
const Schedule = memo(function Schedule(props) {
    const { labels, time_lines, is_baxi_app } = props;
    const intervals_direction = useMemo(() => (is_baxi_app ? 'vertical' : 'horizontal'), [is_baxi_app]);
    return (_jsxs(Box, { position: "relative", width: "100%", height: "100%", children: [_jsx(RangeTimeLine, { intervals_direction: intervals_direction, labels: labels }), _jsx(Box, { className: "day-schedule-editor", display: "flex", flexGrow: 1, height: "100%", flexDirection: intervals_direction === 'horizontal' ? 'column' : 'row', boxSizing: "border-box", gap: 3, pl: is_baxi_app ? 4 : '3px', children: time_lines })] }));
});
export default Schedule;
